import { put, select, takeLatest } from 'redux-saga/effects'
import * as R from '../../constants/Endpoint'
import { errorManagerActionCreators, globalLoadingActionCreators, statisticsActionCreators } from '../actions'
import API_TOKEN, { API_TOKEN_DL_FILE } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import ActionsTypes from '../../constants/ActionsTypes'
import moment from 'moment'


const getStatistics = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_STATISTICS(
			payload.kioskId,
			moment(payload.dateStart).format('YYYY-MM-DD'),
			moment(payload.dateEnd).format('YYYY-MM-DD')
		)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)
		console.log('Data : ',data.data)
		yield put(statisticsActionCreators.getStatisticsSuccess(data.data))
	} catch (e) {
		console.log('Saga error',e)
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(statisticsActionCreators.getStatisticsError(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const exportStatistics = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.EXPORT_STATISTICS()

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN_DL_FILE(user.jwt).post(apiCall)
		console.log('Data : ',data.data)
		yield put(statisticsActionCreators.exportStatisticsSuccess(data.data))

		let filename = data.headers['content-disposition'].split('=')[1]
		let type = data.headers['content-type']
		let url = window.URL.createObjectURL(new Blob([data.data], { type: type }))

		let a = document.createElement('a')
		a.href = url

		a.setAttribute('download', filename)
		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)

	} catch (e) {
		console.log('Saga error',e)
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(statisticsActionCreators.exportStatisticsError(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}




const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_STATISTICS, getStatistics)
	yield takeLatest(ActionsTypes.EXPORT_STATISTICS, exportStatistics)
}

export default sagas